export class InfoFromCisloUjDto {
  isValidCzCisloUj: boolean;
  oblastProvenience: string;
  repMaterialKategorie: number;
  typZdrojeRepMaterialu: string;
  vyskovePasmo: number;
  druhDreviny: string;
  puvodKod: string;
  puvodPlo: string;
  genovaZakladna: string;
}
